<span class="empty-ag-grid-table">
  <img [srcset]="noDataImagePath()" [src]="noDataImagePath()" alt="Stacked paper list image" />
  <ng-container *ngIf="!hasAnyColumnsVisible">{{'customNoRowsOverlay.noColumnsSelected' | transloco}}</ng-container>
  <ng-container *ngIf="hasAnyColumnsVisible">{{'customNoRowsOverlay.noResults' | transloco}}</ng-container>
</span>
